import React from 'react';
import { motion, Variants } from 'framer-motion';
import { Typography } from '@mui/material';

interface LoaderProps {
  text?: string;
}

const Loader = function (props: LoaderProps) {
  const { text } = props;
  const getBlockVariants = (i: number): Variants => ({
    initial: {
      scaleY: i % 2 === 0 ? 1 : 0,
    },
    animate: {
      scaleY: i % 2 === 0 ? [0.5, 1, 0.5] : [1, 0.5, 1],
      transition: {
        duration: 0.6,
        repeat: Infinity,
        ease: 'easeIn',
      },
    },
  });

  const blockStyles = {
    display: 'inline-block',
    width: '7px',
    height: '60px',
    background: 'rgba(249, 113, 113, 1)',
    marginRight: '6px',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
    borderBottomRightRadius: '10px',
    borderBottomLeftRadius: '10px',
  };

  const bottomShadowStyles = {
    borderRadius: '100%',
    background: 'rgba(0, 0, 0, 0.50)',
    filter: 'blur(5px)',
    width: '94px',
    height: '3px',
    flexShrink: '0',
  };

  return (
    <div className="flex gap-2 flex-col items-center">
      <div className="flex items-center justify-center">
        <motion.div
          style={blockStyles}
          variants={getBlockVariants(0)}
          animate="animate"
        />
        <motion.div
          style={blockStyles}
          variants={getBlockVariants(1)}
          animate="animate"
        />
        <motion.div
          style={blockStyles}
          variants={getBlockVariants(2)}
          animate="animate"
        />
        <motion.div
          style={blockStyles}
          variants={getBlockVariants(3)}
          animate="animate"
        />
      </div>
      <div style={bottomShadowStyles} />
      <Typography className="mt-1 font-bold">{text}</Typography>
    </div>
  );
};

Loader.defaultProps = {
  text: 'Please Wait...',
};

export default Loader;
